import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "merchants-chart-container" };
const _hoisted_2 = {
    key: 1,
    class: "no-data"
};
import { computed } from 'vue';
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { BarChart } from 'echarts/charts';
import { GridComponent, TooltipComponent } from 'echarts/components';
import VChart from 'vue-echarts';
export default /*@__PURE__*/ _defineComponent({
    __name: 'TopMerchantsChart',
    props: {
        merchants: {},
        formatter: {},
        colourMode: { default: 'light' }
    },
    emits: ["merchant-click"],
    setup(__props, { emit: __emit }) {
        use([CanvasRenderer, BarChart, GridComponent, TooltipComponent]);
        const props = __props;
        const emit = __emit;
        function handleClick(params) {
            if (params.name) {
                emit('merchant-click', params.name);
            }
        }
        const chartOption = computed(() => {
            if (!props.merchants || props.merchants.length === 0)
                return null;
            const textColor = props.colourMode === 'dark' ? '#e0e0e0' : '#333';
            const gridColor = props.colourMode === 'dark' ? '#333' : '#e0e0e0';
            const names = props.merchants.map((m) => m.name).reverse();
            const values = props.merchants.map((m) => m.value).reverse();
            return {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: { type: 'shadow' },
                    formatter: (params) => {
                        return `${params[0].name}: ${props.formatter.format(params[0].value)}`;
                    }
                },
                grid: {
                    left: '3%',
                    right: '10%',
                    bottom: '3%',
                    top: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'value',
                    axisLine: { lineStyle: { color: gridColor } },
                    splitLine: { lineStyle: { color: gridColor } },
                    axisLabel: {
                        color: textColor,
                        formatter: (value) => {
                            if (value >= 1000)
                                return (value / 1000).toFixed(0) + 'k';
                            return value;
                        }
                    }
                },
                yAxis: {
                    type: 'category',
                    data: names,
                    axisLine: { lineStyle: { color: gridColor } },
                    axisLabel: {
                        color: textColor,
                        width: 100,
                        overflow: 'truncate'
                    }
                },
                series: [
                    {
                        type: 'bar',
                        data: values,
                        itemStyle: {
                            color: {
                                type: 'linear',
                                x: 0, y: 0, x2: 1, y2: 0,
                                colorStops: [
                                    { offset: 0, color: '#9EA2D0' },
                                    { offset: 1, color: '#413655' }
                                ]
                            },
                            borderRadius: [0, 4, 4, 0]
                        },
                        barMaxWidth: 30,
                        label: {
                            show: true,
                            position: 'right',
                            formatter: (params) => props.formatter.format(params.value),
                            color: textColor,
                            fontSize: 11
                        }
                    }
                ]
            };
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (chartOption.value)
                    ? (_openBlock(), _createBlock(_unref(VChart), {
                        key: 0,
                        ref: "chart",
                        option: chartOption.value,
                        style: { height: '100%', width: '100%', cursor: 'pointer' },
                        autoresize: "",
                        onClick: handleClick
                    }, null, 8, ["option"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_2, "No merchant data available"))
            ]));
        };
    }
});
